import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export function MatterRouter() {
  return <section id="matters" className="py-20 lg:py-28 bg-tlfc-cream" data-id="element-310">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10" data-id="element-311">
        {/* Section Header */}
        <div className="reveal max-w-2xl" data-id="element-312">
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-tlfc-text" data-id="element-313">
            What brings you here?
          </h2>
          <p className="mt-4 text-tlfc-text-secondary text-lg" data-id="element-314">
            Select your situation — we'll connect you with the right specialist.
          </p>
        </div>

        {/* Matter Cards Grid */}
        <div className="reveal-stagger mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-315">
          {/* Business & Corporate */}
          <a href="#" className="group bg-white border border-tlfc-border rounded-xl p-7 shadow-soft card-hover hover:border-tlfc-gold/40" data-id="element-316">
            <div className="w-10 h-0.5 bg-tlfc-gold rounded mb-5" data-id="element-317" />
            <h3 className="font-serif text-lg text-tlfc-text group-hover:text-tlfc-gold transition-colors" data-id="element-318">
              Business & Corporate
            </h3>
            <p className="mt-2 text-sm text-tlfc-text-secondary leading-relaxed" data-id="element-319">
              Buying, selling, or growing a business? Get strategic advice that
              protects your interests.
            </p>
            <span className="inline-flex items-center gap-1 mt-5 text-sm text-tlfc-gold font-medium opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-320">
              Learn more
              <ArrowRightIcon className="w-3.5 h-3.5" aria-hidden="true" data-id="element-321" />
            </span>
          </a>

          {/* Property & Development */}
          <a href="#" className="group bg-white border border-tlfc-border rounded-xl p-7 shadow-soft card-hover hover:border-tlfc-gold/40" data-id="element-322">
            <div className="w-10 h-0.5 bg-tlfc-gold rounded mb-5" data-id="element-323" />
            <h3 className="font-serif text-lg text-tlfc-text group-hover:text-tlfc-gold transition-colors" data-id="element-324">
              Property & Development
            </h3>
            <p className="mt-2 text-sm text-tlfc-text-secondary leading-relaxed" data-id="element-325">
              Buying, selling, or developing property? We handle everything from
              contracts to settlement.
            </p>
            <span className="inline-flex items-center gap-1 mt-5 text-sm text-tlfc-gold font-medium opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-326">
              Learn more
              <ArrowRightIcon className="w-3.5 h-3.5" aria-hidden="true" data-id="element-327" />
            </span>
          </a>

          {/* Litigation & Dispute Resolution */}
          <a href="#" className="group bg-white border border-tlfc-border rounded-xl p-7 shadow-soft card-hover hover:border-tlfc-gold/40" data-id="element-328">
            <div className="w-10 h-0.5 bg-tlfc-gold rounded mb-5" data-id="element-329" />
            <h3 className="font-serif text-lg text-tlfc-text group-hover:text-tlfc-gold transition-colors" data-id="element-330">
              Litigation & Disputes
            </h3>
            <p className="mt-2 text-sm text-tlfc-text-secondary leading-relaxed" data-id="element-331">
              Facing a dispute? We resolve matters with precision and commercial
              pragmatism.
            </p>
            <span className="inline-flex items-center gap-1 mt-5 text-sm text-tlfc-gold font-medium opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-332">
              Learn more
              <ArrowRightIcon className="w-3.5 h-3.5" aria-hidden="true" data-id="element-333" />
            </span>
          </a>

          {/* Owners Corporations */}
          <a href="#" className="group bg-white border border-tlfc-border rounded-xl p-7 shadow-soft card-hover hover:border-tlfc-gold/40" data-id="element-334">
            <div className="w-10 h-0.5 bg-tlfc-gold rounded mb-5" data-id="element-335" />
            <h3 className="font-serif text-lg text-tlfc-text group-hover:text-tlfc-gold transition-colors" data-id="element-336">
              Owners Corporations
            </h3>
            <p className="mt-2 text-sm text-tlfc-text-secondary leading-relaxed" data-id="element-337">
              Strata issues or committee disputes? Specialist guidance from
              lawyers who know OC law.
            </p>
            <span className="inline-flex items-center gap-1 mt-5 text-sm text-tlfc-gold font-medium opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-338">
              Learn more
              <ArrowRightIcon className="w-3.5 h-3.5" aria-hidden="true" data-id="element-339" />
            </span>
          </a>

          {/* Family Law */}
          <a href="#" className="group bg-white border border-tlfc-border rounded-xl p-7 shadow-soft card-hover hover:border-tlfc-gold/40" data-id="element-340">
            <div className="w-10 h-0.5 bg-tlfc-gold rounded mb-5" data-id="element-341" />
            <h3 className="font-serif text-lg text-tlfc-text group-hover:text-tlfc-gold transition-colors" data-id="element-342">
              Family Law
            </h3>
            <p className="mt-2 text-sm text-tlfc-text-secondary leading-relaxed" data-id="element-343">
              Going through separation or a family matter? Compassionate,
              strategic support when you need it most.
            </p>
            <span className="inline-flex items-center gap-1 mt-5 text-sm text-tlfc-gold font-medium opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-344">
              Learn more
              <ArrowRightIcon className="w-3.5 h-3.5" aria-hidden="true" data-id="element-345" />
            </span>
          </a>

          {/* Employment Law */}
          <a href="#" className="group bg-white border border-tlfc-border rounded-xl p-7 shadow-soft card-hover hover:border-tlfc-gold/40" data-id="element-346">
            <div className="w-10 h-0.5 bg-tlfc-gold rounded mb-5" data-id="element-347" />
            <h3 className="font-serif text-lg text-tlfc-text group-hover:text-tlfc-gold transition-colors" data-id="element-348">
              Employment Law
            </h3>
            <p className="mt-2 text-sm text-tlfc-text-secondary leading-relaxed" data-id="element-349">
              Workplace issue or unfair treatment? We protect your rights and
              fight for fair outcomes.
            </p>
            <span className="inline-flex items-center gap-1 mt-5 text-sm text-tlfc-gold font-medium opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-350">
              Learn more
              <ArrowRightIcon className="w-3.5 h-3.5" aria-hidden="true" data-id="element-351" />
            </span>
          </a>
        </div>

        {/* Help Link */}
        <div className="reveal mt-10 text-center" data-id="element-352">
          <a href="#contact" className="inline-flex items-center gap-2 text-tlfc-text-secondary hover:text-tlfc-gold transition-colors text-sm" data-id="element-353">
            Not sure where to start? Tell us what's happening
            <ArrowRightIcon className="w-4 h-4" aria-hidden="true" data-id="element-354" />
          </a>
        </div>
      </div>
    </section>;
}